export default __webpack_public_path__ + "static/media/IMG-20210701-WA0028.e517bc79.jpg";